// Modular standard library for JavaScript ( polyfills )
import 'core-js/stable';
import 'regenerator-runtime/runtime';

// Metronic & plugins
import 'metronic';
import 'toastr';

import {
  custom_popover,
} from '_form_helpers';

import '@hotwired/turbo-rails';
import '@rails/actioncable';
import 'controllers';
import * as RequestJS from '@rails/request.js';

window.Turbo.session.drive = false;

// Prevent Turbo from restoring hash-based history entries, which can cause
// the page scripts to execute multiple times during browser Back navigation.
function stripHistoryState(){
  history.replaceState( null, '', location.href );
}

document.addEventListener( 'DOMContentLoaded', stripHistoryState );
window.addEventListener( 'hashchange', stripHistoryState );

window.RequestJS = RequestJS;

import * as ActiveStorage from '@rails/activestorage';
ActiveStorage.start();

$( document ).on( 'click', '.copy_to_clipboard', function(){
  const $this = $( this );
  const range = document.createRange();
  range.selectNode( $this.prev().get( 0 ) );
  window.getSelection().removeAllRanges();
  window.getSelection().addRange( range );

  try {
    document.execCommand( 'copy' );
    window.toastr.success( 'Copied to clipboard!' );
  } catch( err ) {
    window.toastr.error( 'Oops, copy failed' );
  }

  window.getSelection().removeAllRanges();

  return false;
} );

$( function(){
  custom_popover( '.items-popover' );

  // Metronic 8.x components
  $( '.menu-item.menu-accordion .menu-link' ).on( 'click', function(){
    $( this ).parent().toggleClass( 'show' );
    $( this ).parent().find( '.menu-sub.menu-sub-accordion' ).toggleClass( 'show' );
  } );
} );

/* flash/toastr updates */
function flash_update(){
  let txt = $( 'turbo-frame#flash script' ).text(),
      list;

  if( txt == '' ){ return; }

  list = JSON.parse( txt );

  for( var i = 0; i < list.length; i++ ){
    window.toastr[ list[ i ][ 0 ] ]( list[ i ][ 1 ] );
  }
}
$( function(){
  flash_update();

  let flash = $( 'turbo-frame#flash' )[ 0 ];

  if( flash == undefined ){ return; }

  new MutationObserver( flash_update ).observe( flash, { childList: true } ); }
);
